import React from 'react'
import { Link } from 'react-router-dom'
import { Stack, Button } from 'rsuite'
import path from 'path'

interface Props {
  to?: any[]
  children: string
}

export default class TableFooter extends React.Component<Props> {
  render() {
    const { to, children } = this.props

    let url = path.join(window.location.pathname, 'new')
    if (to) url = path.join(...to)

    return (
      <Stack className='footer' justifyContent='center'>
        <Button as={Link} to={url} appearance='primary'>
          {children}
        </Button>
      </Stack>
    )
  }
}
